export default __webpack_public_path__ + "static/media/dev-basic-java.b4098606.png";